import { Outlet } from "react-router-dom";
import { TravlDataProvider } from "./TravlContext";

export default function TravlLayout() {
    return (
        <TravlDataProvider>
            <Outlet />
        </TravlDataProvider>
    );
};